<template>
<div class="chapter">
<div class="inner_page">
<p class="h2a"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">contents</span></span></p>
<p class="toct" id="krintro"><a href="#/text/Introduction#kintro">INTRODUCTION</a></p>
<p class="toc" id="krch1"><span href="#/text/Chapter01#kch1" title="Link target outside of Sample">Flowers &amp; Terrariums</span></p>
<p class="toc" id="krch2"><span href="#/text/Chapter02#kch2" title="Link target outside of Sample">SANS SERIF</span></p>
<p class="toc" id="krch3"><span href="#/text/Chapter03#kch3" title="Link target outside of Sample"><b>SERIF</b></span></p>
<p class="toc" id="krch4"><span href="#/text/Chapter04#kch4" title="Link target outside of Sample"><b>Script</b></span></p>
<p class="toc" id="krch5"><span href="#/text/Chapter05#kch5" title="Link target outside of Sample">BLOCK and DIMENSIONAL</span></p>
<p class="toc" id="krch6"><span href="#/text/Chapter06#kch6" title="Link target outside of Sample">COMBINING Styles</span></p>
<p class="toc" id="krch7"><span href="#/text/Chapter07#kch7" title="Link target outside of Sample">POSITIVE and NEGATIVE Spaces</span></p>
<p class="toc" id="krch8"><span href="#/text/Chapter08#kch8" title="Link target outside of Sample">EMBELLISHMENTS and BORDERS</span></p>
<p class="toc" id="krch9"><span href="#/text/Chapter09#kch9" title="Link target outside of Sample">FRUITS and VEGGIES</span></p>
<p class="toc" id="krch10"><span href="#/text/Chapter10#kch10" title="Link target outside of Sample"><b>brush lettering</b></span></p>
<p class="toc" id="krch11"><span href="#/text/Chapter11#kch11" title="Link target outside of Sample">MANY WAYS</span></p>
<p class="toc" id="krch12"><span href="#/text/Chapter12#kch12" title="Link target outside of Sample"><b>BEYOND</b> the <b>PAGE</b></span></p>
<p class="toc" id="krauthor"><span href="#/text/Author#kauthor" title="Link target outside of Sample">ABOUT the AUTHOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?65e24ff6